import { ModalContentToggler } from '@components'

import { Attachment, ModalProps, useModal } from '@billy/design-system'
import { ReactElement, useState } from 'react'

import { attachmentModalSteps } from '../../../attachments/constants/attachmentModalSteps'
import { getAttachmentPreviewModalId } from '../AttachmentList/utils/getAttachmentPreviewModalId'
import { AttachmentPreviewModalContextProvider } from '../AttachmentPreviewModal/context/attachmentPreviewModalContext'
import { ChooseAttachmentModalContextProvider } from './contexts/chooseAttachmentModalContext'

export interface ChooseFromUploadsModalProps extends ModalProps {
  idsToSkip?: string[]
  onSelect: (file: Attachment) => void
}

export const ChooseAttachmentModal = ({
  idsToSkip,
  onSelect,
  id,
  ...rest
}: ChooseFromUploadsModalProps): ReactElement => {
  const [selectedAttachment, setSelectedAttachment] = useState<Attachment | undefined>(undefined)

  const { close: closeAttachmentModal } = useModal(id)

  const attachmentPreviewModalId = getAttachmentPreviewModalId(selectedAttachment?.id || '')

  const handleAttachmentSelectFromModal = () => {
    if (selectedAttachment) {
      onSelect(selectedAttachment)
      closeAttachmentModal()
    }
  }

  return (
    <ChooseAttachmentModalContextProvider
      modalId={id}
      onFileImageClick={setSelectedAttachment}
      onSelect={onSelect}
      idsToSkip={idsToSkip}
    >
      <AttachmentPreviewModalContextProvider
        attachment={selectedAttachment}
        modalId={attachmentPreviewModalId}
        onFileSelect={handleAttachmentSelectFromModal}
        trackingSource="purchases"
      >
        <ModalContentToggler
          initialState="select"
          states={attachmentModalSteps}
          withTransition={false}
          id={id}
          {...rest}
        />
      </AttachmentPreviewModalContextProvider>
    </ChooseAttachmentModalContextProvider>
  )
}
